export const GUEST_MENU_NAMESPACE = "guestMenu";

/**
 * Query param that overrides the detected language. Lives here rather than with
 * the instance because `app/index.html` has to read it too, before any bundle
 * loads, to declare `<html lang>` in time for the browser's translate decision.
 */
export const LANGUAGE_QUERY_PARAM = "lang";

export const FALLBACK_LANGUAGE = "en";

export const SUPPORTED_LANGUAGES = ["en", "fr", "it", "es", "de"] as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

/** Shown in a language picker; each name is written in its own language. */
export const LANGUAGE_NAMES: Record<SupportedLanguage, string> = {
  en: "English",
  fr: "Français",
  it: "Italiano",
  es: "Español",
  de: "Deutsch",
};

export const isSupportedLanguage = (
  value: string | undefined
): value is SupportedLanguage =>
  !!value && (SUPPORTED_LANGUAGES as readonly string[]).includes(value);
